import React from 'react';
import PropTypes from 'prop-types';
import styles from './onboarding-content.less';

const OnboardingContent = ({ width, imgUrl, title, description }) => (
  <div className={styles.onboardingContent} style={{ width }}>
    {imgUrl && <img src={imgUrl} alt={title} className={styles.img} />}
    <div className={styles.title}> {title} </div>
    {description && <div className={styles.description}> {description} </div>}
  </div>
);

OnboardingContent.propTypes = {
  width: PropTypes.number,
  imgUrl: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

OnboardingContent.defaultProps = {
  width: undefined,
  imgUrl: undefined,
  description: undefined,
};

export default OnboardingContent;
